import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import theme from './themes/default';
import Favicon from 'react-favicon';
import step1 from 'Images/favicon.png';

import App from './App';
import store from './store';

window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
// if (process.env.NODE_ENV !== 'production') {
//   const { whyDidYouUpdate } = require('why-did-you-update');
//   whyDidYouUpdate(React);
// }

ReactDOM.render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <Favicon url={step1} />
      <App />
    </MuiThemeProvider>
  </Provider>,
  document.getElementById('app')
);
